import { inject, Injectable } from '@angular/core';
import { DroplistItem, PageTabsLayoutPageService } from '@eforall/dashboard';
import { VolunteeringAreaService } from '../volunteering-area.service';


/**
 * The list of tabs on this page
 */
export enum VolunteeringMentorsPageTabId {
	Mentors = 1,
	Tab1 = 2,
	Tab2 = 3,
}

/**
 * The list of main tab droplist views on this page
 */
export enum VolunteeringMentorsPageViewId {
	MentorPool = 1,
	PendingSignUps = 2,
	RejectedSignUps = 3,
	AcceptedSignUps = 4,
	Backups = 5,
	AllMentors = 6,
	DroppedOutMentors = 7
}


@Injectable({ providedIn: 'root' })
export class VolunteeringMentorsService extends PageTabsLayoutPageService<VolunteeringMentorsPageTabId, VolunteeringMentorsPageViewId> {
	public readonly areaService = inject(VolunteeringAreaService);
	private static readonly _viewDroplistItems1: DroplistItem<never, VolunteeringMentorsPageViewId>[] = [
		{
			uniqueId: VolunteeringMentorsPageViewId.MentorPool,
			iconContext: {
				iconClass: 'fa-grip-horizontal',
				iconStyle: 'fa-solid',
				text: 'Mentor Pool',
				hideText: 'never',
			},
			groupName: 'Overview',
			customSort: '1-Overview-1'
		},
		{
			uniqueId: VolunteeringMentorsPageViewId.PendingSignUps,
			iconContext: {
				iconClass: 'fa-grip-horizontal',
				iconStyle: 'fa-solid',
				text: 'Pending Sign-ups',
				hideText: 'never',
			},
			groupName: 'Sign-ups',
			customSort: '2-Sign-ups-1'
		},
		{
			uniqueId: VolunteeringMentorsPageViewId.RejectedSignUps,
			iconContext: {
				iconClass: 'fa-grip-horizontal',
				iconStyle: 'fa-solid',
				text: 'Rejected Sign-ups',
				hideText: 'never',
			},
			groupName: 'Sign-ups',
			customSort: '2-Sign-ups-2'
		},
		{
			uniqueId: VolunteeringMentorsPageViewId.AcceptedSignUps,
			iconContext: {
				iconClass: 'fa-grip-horizontal',
				iconStyle: 'fa-solid',
				text: 'Accepted Sign-ups',
				hideText: 'never',
			},
			groupName: 'Sign-ups',
			customSort: '2-Sign-ups-3'
		},
		{
			uniqueId: VolunteeringMentorsPageViewId.Backups,
			iconContext: {
				iconClass: 'fa-grip-horizontal',
				iconStyle: 'fa-solid',
				text: 'Back-ups',
				hideText: 'never',
			},
			groupName: 'Sign-ups',
			customSort: '2-Sign-ups-4'
		},
		{
			uniqueId: VolunteeringMentorsPageViewId.AllMentors,
			iconContext: {
				iconClass: 'fa-user-tie',
				iconStyle: 'fa-solid',
				text: 'All Mentors',
				hideText: 'never',
			},
			groupName: 'In-Cohort',
			customSort: '3-In-Cohort-1'
		},
		{
			uniqueId: VolunteeringMentorsPageViewId.DroppedOutMentors,
			iconContext: {
				iconClass: 'fa-user-slash',
				iconStyle: 'fa-solid',
				text: 'Dropped-out Mentors',
				hideText: 'never',
			},
			groupName: 'In-Cohort',
			customSort: '3-In-Cohort-2'
		},
	];
	constructor() {
		super(VolunteeringMentorsService._viewDroplistItems1, VolunteeringMentorsService.name, VolunteeringMentorsPageTabId.Mentors, VolunteeringMentorsPageViewId.PendingSignUps);
	}

	public get viewId() {
		return VolunteeringMentorsPageViewId;
	}

}